import React from "react";
import { IoIosArrowForward } from "react-icons/io";

const AboutHeader = () => {
  return (
    <>
      <section id="hero" className="main-banner">
        <div className="container">
          <div className="breadcrumb-block">
            <h1 className="text-white">About</h1>
            <div className="breadcrumb-merge">
              <a href="/" className="breadcrumb">
                Home
              </a>
              <div className="icon"></div>
              <IoIosArrowForward />
              <div className="breadcrumb">About</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutHeader;
